export enum VCAPopupContent {
  INVITATION = 'INVITATION'
}

export interface IVCAState {
  popup?: VCAPopupContent;
}
